module.exports = function () {
	$('.A1-header__navigation .A1-header__link.has-flyout-menu').mouseenter(function () {
		$(this).closest('.A1-header').removeClass('has-search-active');
		$('.A1-header__dropdown').removeClass('is-active');
		var entryId = $(this).data('id');
		$(".A1-header__dropdown[data-entry-id='" + entryId + "']").addClass('is-active');
	}).mouseleave(function() {
		var entryId = $(this).data('id');
		if ($(".A1-header__dropdown[data-entry-id='" + entryId + "']:hover").length == 0) {
			$('.A1-header__dropdown').removeClass('is-active');
		}
	});

	$('.A1-header__navigation .A1-header__link.has-flyout-menu').click(function(e) {
		e.preventDefault();
	});

	$('.A1-header__dropdown-wrapper').not('.mobile-menu').mouseleave(function () {
		$(this).closest('.A1-header__dropdown').removeClass('is-active');
	});

	$('.A1-header__hamburger').click(function () {
		$(this).closest('.A1-header').removeClass('has-search-active');
		$(this).closest('.A1-header').toggleClass('has-menu-active');
		$('.A1-header__dropdown.mobile-menu').toggleClass('is-active');
	});

	$('.A1-header__dropdown.mobile-menu .A3-mega-dropdown__link.has-sub-pages, .A1-header__dropdown.mobile-menu .A3-mega-dropdown__title').click(function (e) {
		e.preventDefault();
		var dataId = $(this).data('entryId');
		$(this).closest('.A3-mega-dropdown__inner').removeClass('is-active');
		$(".A1-header__dropdown.mobile-menu .A3-mega-dropdown__inner[data-entry-id='" + dataId + "']")
			.addClass('is-active');
	});

	$('.A3-mega-dropdown__list .has-sub-pages').mouseenter(function() {
		$('.A3-mega-dropdown__column').removeClass('is-active');
		var id = $(this).data('subpageId');
		$(this).closest('.A3-mega-dropdown__navigation')
			.find(".A3-mega-dropdown__column[data-parent-id='" + id + "']")
			.addClass('is-active');
	});
};
